export const setModalSale = (sale) => ({
    type: "SET_MODAL_SALE",
    payload: sale,
});
